module.exports = __webpack_public_path__ + "img/hu5.92574979.jpg";